import timer_gen_2 from '@devices/settings/device_settings/timer_gen_2.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import sensor_settings_wall_display from '@devices/settings/device_settings/sensor_settings_wall_display.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import ui_settings_gen_2_x from '@devices/settings/device_settings/ui_settings_gen_2_x.js';
import networks_gen_wall_display from '@devices/settings/device_settings/networks_gen_wall_display.js';
import app_setting_gen_2_no_appliance from '@devices/settings/device_settings/app_setting_gen_2_no_appliance.js';
import share from '@devices/settings/device_settings/share.js';
import settings_gen_2_wall_display from '@devices/settings/device_settings/settings_gen_2_wall_display.js';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2';
import virtual_components_wall_display from '@devices/settings/device_settings/virtual_components_wall_display';
import scripts_gen_2_wall_display from '@devices/settings/device_settings/scripts_gen_2_wall_display';

export default {
	name: 'ShellyWallDisplay',
	friendly_name: 'Wall Display X2',
	reset_from_input: true,
	family: 'relay',
	isPM: false,
	dashInfoLabels: 'wall-display',
	modes: {
		relay: {
			dashInfoLabels: 'wall-display',
			availableViews: ['basic', 'advanced'],
			channels: 1,
			settings: [
				timer_gen_2,
				schedule_gen_2,
				sensor_settings_wall_display,
				webhooks_gen_2,
				ui_settings_gen_2_x,
				networks_gen_wall_display,
				bluetooth_gen_2,
				virtual_components_wall_display,
				scripts_gen_2_wall_display,
				app_setting_gen_2_no_appliance,
				share,
				settings_gen_2_wall_display,
			],
			notifications: ['offline', 'device_problem'],
		},
		media_player: {
			dashInfoLabels: 'wall-display',
			availableViews: ['advanced'],
			channels: 1,
			settings: [
				share,
				{
					title: 'application_settings',
					components: [{ title: 'pin_lock', component: 'pin_lock' }],
				},
				{
					title: 'settings',
					components: [{ title: 'device_information', component: 'device_information' }],
				},
			],
		},
		thermostat: {
			dashInfoLabels: 'wall-display',
			availableViews: ['advanced'],
			channels: 1,
			settings: [
				share,
				{
					title: 'application_settings',
					components: [{ title: 'pin_lock', component: 'pin_lock' }],
				},
				{
					title: 'settings',
					components: [{ title: 'device_information', component: 'device_information' }],
				},
			],
		},
	},
};
